import "./index.css";
import React from "react";
import { Popconfirm } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

interface TypeItemProps {
  title?: string;
  onDelete?(): void;
  children?: React.ReactNode;
}

/**
 * @name Item 编辑项
 */
const Item: React.FC<TypeItemProps> = ({ title, onDelete, children }) => (
  <div className="edit-website-item">
    <div className="edit-website-item-header">
      <span>{title}</span>
      <Popconfirm
        title="Warning"
        onConfirm={onDelete}
        description="Sure you want to delete it?"
      >
        <DeleteOutlined rev={undefined} />
      </Popconfirm>
    </div>
    {children}
  </div>
);

export default Item;
